module.exports = __webpack_public_path__ + "media/images/selected_rectangle-79b04c8bb47790f944c597719e093c13.png";